/**
 * Listeden filtre ile en fazla `limit` benzersiz ilan döndürür.
 */
export const pickListingsByType = (listings, matchFn, limit = 4) => {
  if (!Array.isArray(listings) || typeof matchFn !== "function") return [];

  const result = [];
  const seen = new Set();

  for (const item of listings) {
    if (result.length >= limit) break;
    if (!matchFn(item)) continue;
    const id = item?.id;
    if (id != null && seen.has(id)) continue;
    if (id != null) seen.add(id);
    result.push(item);
  }

  return result;
};
